export default "__VITE_ASSET__NfpOI1kP__"